<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Items</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="importar" type="button" class="btn-success btn--bigger">
            <i class="fa fa-download"></i><span>Importar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table @crear="crear" @editar="editar" @eliminar="eliminar" :path="path" :editButton="puedeEditar"
          :deleteButton="puedeAnular" :createButton="puedeCrear" ref="items" :columns="[
            {
              display: 'Código',
              value: 'codigo',
            },
            {
              display: 'Descripción',
              value: 'descripcion',
            },
            {
              display: 'Precio',
              value: 'precio',
              numeric: true,
              prefijo: '$',
            },
            {
              display: 'Costo',
              value: 'costo',
              numeric: true,
              prefijo: '$',
            },
            {
              display: 'Código de barra',
              value: 'codigo_barra',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Fecha de importación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            },
          ]"></k-table>
      </div>
    </div>
    <modal height="auto" width="75%" name="edicionItem" scrollable adaptive reset resizable>
      <edicion-item @preciosActualizados="preciosActualizados" @uploaded="uploadedFoto" :urlFoto="urlFoto"
        @cerrar="$modal.hide('edicionItem')" :itemId="itemId" :descripcionItem="descripcionItem" v-model="selectedItem">
      </edicion-item>
    </modal>
  </div>
</template>

<script>
import EdicionItem from "./EdicionItem.vue";

export default {
  components: {
    EdicionItem,
  },
  props: {
    puedeCrear: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditar: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAnular: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: function () {
    return {
      path: url + "/inventario/items",
      descripcionItem: "",
      itemId: "",
      urlFoto: null,
      selectedItem: null,
    };
  },
  methods: {
    importar: function () {
      axios
        .get(url + "/inventario/importar-items")
        .then(() => {
          swal(
            "La importación fue realizada exitósamente.",
            "Realizado",
            "success"
          );
          this.$refs.items.loadRows();
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    preciosActualizados: function () {
      this.$refs.items.loadRows();
    },
    uploadedFoto: function () {
      this.$modal.hide("edicionItem");
      this.$refs.items.loadRows();
    },
    crear: function () {
      this.selectedItem = {
        id: null,
        codigo: '',
        descripcion: '',
        codigo_barra: '',
        costo: '',
        precio: '',
        precio2: '',
        precio3: '',
        archivo: null,
        url_foto: null,
      };
      this.$modal.show("edicionItem");
    },
    editar: function (row) {
      this.descripcionItem = row.descripcion;
      this.itemId = row.id;
      this.urlFoto = row.url_foto;
      this.selectedItem = row;
      this.selectedItem.archivo = null;
      this.$modal.show("edicionItem");
    },
    eliminar: function (row) {
      swal({
        title: `¿Desea ${row.estado == 'A' ? 'anular' : 'reactivar'} el item?`,
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlApi = `${url}/inventario/item/anular/${row.id}`;
          axios
            .post(urlApi)
            .then(response => {
              let nuevoEstado = response.data.nuevo_estado;
              swal(
                'Realizado',
                `El item ha sido ${nuevoEstado == 'A' ? 'reactivado' : 'anulado'}`,
                'success'
              );
              this.$refs.items.loadRows();
            })
            .catch(error => {
              swal('Error', 'No se pudo realizar la operación', 'error');
            });
        }
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/Items.vue